import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../styles/pages/usefull-info_page.css";
import Header from "../components/Header.jsx";
import Button from "../components/Button.jsx";
import Loader from "../components/Loader";
import NoImageItem from "../components/NoImageItem.jsx";
import UsefullInfoForm from "../components/UsefullInfoForm.jsx";
import Modal from "../components/Modal.jsx";
import { fetchUsefulInfos, deleteUsefulInfo } from "../services/usefulInfoService";

const UsefullInfoPage = () => {
    const [tipsItems, setTipsItems] = useState([]);
    const [showUsefullInfoForm, setShowUsefullInfoForm] = useState(false);
    const [usefullInfoFormMode, setUsefullInfoFormMode] = useState("create");
    const [currentUsefullInfoData, setCurrentUsefullInfoData] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const loadData = async () => {
        setIsLoading(true);
        try {
            const data = await fetchUsefulInfos().catch((err) => {
                if (err.response?.status === 404) return [];
                throw err;
            });

            setTipsItems(
                Array.isArray(data)
                    ? data.map(item => ({
                        id: item.id,
                        title: item.title,
                        createdAt: item.createdAt,
                        description: item.description,
                        hasEdit: true
                    }))
                    : []
            );
        } catch (error) {
            if (error.response?.status === 403) {
                toast.error("Время сессии истекло, пожалуйста войдите заново", {
                    position: "bottom-left",
                    autoClose: 3000
                });
            } else {
                toast.error("Ошибка загрузки данных", {
                    position: "bottom-left",
                    autoClose: 3000
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleAddUsefullInfo = () => {
        setUsefullInfoFormMode("create");
        setCurrentUsefullInfoData(null);
        setShowUsefullInfoForm(true);
    };

    const handleEditUsefullInfo = (item) => {
        setUsefullInfoFormMode("edit");
        setCurrentUsefullInfoData(item);
        setShowUsefullInfoForm(true);
    };

    const handleDeleteItem = (item) => {
        setDeleteTarget(item);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setDeleteTarget(null);
    };

    const confirmDelete = async () => {
        if (!deleteTarget) return;

        try {
            await deleteUsefulInfo(deleteTarget.id);
            await loadData();
            toast.success("Полезная информация успешно удалена", {
                position: "bottom-left",
                autoClose: 3000
            });
        } catch (error) {
            if (error.response?.status === 403) {
                toast.error("Время сессии истекло, пожалуйста войдите заново", {
                    position: "bottom-left",
                    autoClose: 3000
                });
            } else {
                toast.error("Ошибка при удалении", {
                    position: "bottom-left",
                    autoClose: 3000
                });
            }
        } finally {
            closeDeleteModal();
        }
    };

    return (
        <div className="usefull-info-page">
            <Header />
            <ToastContainer />

            {isLoading ? (
                <div className="loader-wrapper">
                    <Loader />
                    <p className="loading-text">Загрузка полезной информации...</p>
                </div>
            ) : (
                <div className="usefull-info-page_content">
                    <div className="tips_section">
                        <h3 className="section-title">Список полезной информации</h3>
                        <div className="items-container">
                            {tipsItems.length > 0 ? (
                                tipsItems.map((item, index) => (
                                    <div key={item.id} className="numbered-item">
                                        <span className="item-number">{index + 1}</span>
                                        <NoImageItem
                                            title={item.title}
                                            subtitle={item.createdAt}
                                            onEdit={() => handleEditUsefullInfo(item)}
                                            onDelete={() => handleDeleteItem(item)}
                                        />
                                    </div>
                                ))
                            ) : (
                                <p className="empty-list-label">Список пуст</p>
                            )}
                            <Button
                                text={"+ Добавить"}
                                onClick={handleAddUsefullInfo}
                            />
                        </div>
                    </div>
                </div>
            )}

            {showUsefullInfoForm && (
                <UsefullInfoForm
                    mode={usefullInfoFormMode}
                    initialData={currentUsefullInfoData}
                    onClose={() => setShowUsefullInfoForm(false)}
                    onSuccess={loadData}
                />
            )}

            {showDeleteModal && (
                <Modal
                    isOpen={showDeleteModal}
                    message="Вы действительно хотите удалить полезную информацию:"
                    itemTitle={deleteTarget?.title || ""}
                    onCancel={closeDeleteModal}
                    onConfirm={confirmDelete}
                />
            )}
        </div>
    );
};

export default UsefullInfoPage;
